import * as qs from 'qs';
import { NPS_SCORE_INTERSECTION } from './constants';

/**
 * FormData.entries を parse し Array へ変換します
 *
 * Polyfillのentries()がスプレッド構文だとうまく展開できない？ 問題が発生 - https://github.com/jimmywarting/FormData
 *
 * @param {*} entries FormData.entries value - native value と polyfill value では処理を変更する
 * @return {Array<Array<string, string>>} FormData.entries を parse し Array 変換し返します
 * @see https://jira.rakuten-it.com/jira/browse/UXDCOEIPS-242 - No data seems to be sent to enen on IE11
 */
const entriesToArray = entries => {
  let result = [...entries];
  if (result && result.length) {
    return result;
  }
  // console.log('entriesToArray - entries ', result, entries)
  result = [];
  for (let data of entries) {
    result.push(data);
  }
  return result;
};

/**
 * FormData を Object 変換し `qs` を通し文字列変換します
 * - checkbox value は name 属性が同一なので
 * @param {FormData} formData survey form data
 * @param {*} config send key name and value
 * @return {string} `qs`.stringify 変換後文字列を返します
 */
export const parseFormDataToQs = (formData, config) => {
  const { inquiry, inquiryNegative, nps } = config;
  const options =
    nps.checked < NPS_SCORE_INTERSECTION && inquiryNegative.checkList.available
      ? inquiryNegative.checkList.options
      : inquiry.checkList.options;
  const optionName = options[0].name;

  // const entries = [...formData.entries()];
  const entries = entriesToArray(formData.entries());
  const result = {};
  const checked = [];
  entries.map(data => {
    const [name, value] = data;
    if (name !== optionName) {
      result[name] = value;
    } else {
      checked.push(value);
    }
    return checked;
  });
  result[optionName] = checked;
  // @see https://github.com/ljharb/qs#stringifying
  // You may override this by setting the indices option to false:
  //
  // qs.stringify({ a: ['b', 'c', 'd'] }, { indices: false });
  // 'a=b&a=c&a=d'
  return qs.stringify(result, { indices: false });
};

/**
 * survey form 送信します
 * @param {string} path api endpoint
 * @param {FormData|string} body form data or qs.stringify
 * @param {string} [method=POST]
 * @return {Promise<Response | void>} Promise
 */
const ajax = (path, body, method = 'POST') => {
  const headers = new Headers({
    'Content-Type': 'application/x-www-form-urlencoded',
  });
  // const parsed = parseFormDataToQs(body);
  // console.log('ajax - body', body)
  const option = {
    cache: 'no-cache',
    mode: 'cors',
    credentials: 'include',
    body,
    method,
    headers,
  };
  // {Request}
  const request = new Request(path, option);
  return fetch(request)
    .then(response => response)
    .catch(error => console.error(`fetch error - ${path}`, error));
};

export default ajax;



// WEBPACK FOOTER //
// ./src/phase2/survey/app/ajax.js